@if (isEdit()) {
  <h2 mat-dialog-title>Edit Harbour</h2>
} @else {
  <h2 mat-dialog-title>Add Harbour</h2>
}

<mat-dialog-content>
  <form id="harbour-form" [formGroup]="harbourForm" (ngSubmit)="submit()">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Place</mat-label>
        <input matInput formControlName="place" />
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Country</mat-label>
        <input matInput formControlName="country" />
      </mat-form-field>
    </p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-flat-button
    type="submit"
    form="harbour-form"
    [disabled]="harbourForm.pristine || !harbourForm.valid"
  >
    Save
  </button>
  <button mat-button type="button" (click)="cancel()">Cancel</button>
</mat-dialog-actions>
